var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lyf-ui-loading"},[_c('div',{staticClass:"lyf-ui-loading-cont",class:{ 'vertical': _vm.vertical === true }},[_c('div',{ref:"loadingContainer",staticClass:"lyf-ui-loading-icon",style:({
			width: _vm.size + 'px',
			height: _vm.size + 'px'
		})}),_c('div',{staticClass:"lyf-ui-text",style:({
			color: _vm.fontColor,
			fontSize: _vm.fontSize + 'px'
		})},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }